import React from 'react';
import Layout from '../templates/DefaultLayout';
import ShowUsers from './ShowUsers';

const UserAdminPage = () => {
    return (
        <Layout title="User Administration" subtitle="">
            <div className="container flex flex-col py-4">
                <ShowUsers />
            </div>
        </Layout>
    );
};

export default UserAdminPage;